import React from 'react';
import styled from 'styled-components';
import { selectColor } from '@panel/commons';
import noImage from '@panel/commons/assets/icons/aviso-sin-foto.svg';

function Picture({ urlPicture, openDetailPosting }) {
  return (
    <ContentLayout onClick={openDetailPosting}>
      {urlPicture ? (
        <PictureContainer urlPicture={urlPicture} data-panel='posting-img' />
      ) : (
        <WithoutImage>
          <img src={noImage} alt='Aviso sin imagen' data-panel='posting-img-sinImagen' />
        </WithoutImage>
      )}
    </ContentLayout>
  );
}

const ContentLayout = styled.div`
  border-radius: 4px;
  height: 95px;
  min-width: 95px;
  overflow: hidden;
  margin-right: 15px;
`;

const PictureContainer = styled.div`
  height: 100%;
  width: 100%;
  background: url(${({ urlPicture }) => urlPicture !== '' && urlPicture}) no-repeat;
  background-position: center;
  background-size: cover;
`;

const WithoutImage = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${selectColor('grayMediumLight')};
  display: flex;
  justify-content: center;
  align-items: center;
  > img {
    height: 30px;
  }
`;

export default Picture;
